import axios from 'axios'
import { useMemo } from 'react'

export const useApiClient = () => {
  return useMemo(
    () =>
      axios.create({
        baseURL: '/api',
        headers: { 'Content-Type': 'application/json' },
      }),
    []
  )
}
